(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted='true';
    const video=root.querySelector('video'), reduce=matchMedia('(prefers-reduced-motion: reduce)');
    const reveals=[...root.querySelectorAll('[data-reveal]')];
    const captions=['01 · Votre plaque, à l’image de votre commerce.','02 · Le téléphone détecte la puce NFC.','03 · Touchez la notification pour ouvrir votre page.','04 · Essayez les boutons du Smart Link sur le téléphone.'];
    let target=0, raf=0, active=true, mediaFailed=root.classList.contains('is-static');
    function tick(){
      raf=0;
      if(!active || reduce.matches || mediaFailed || root.classList.contains('is-interactive') || !Number.isFinite(video.duration)) return;
      // Wait for the decoder: never stack seeks. Full-frame GOP1 export allows arbitrary scroll positions.
      if(!video.seeking && Math.abs(video.currentTime-target)>.025) video.currentTime=video.currentTime+(target-video.currentTime)*.35;
    }
    function sync(){
      const rect=root.getBoundingClientRect();
      const p=Math.min(1,Math.max(0,-rect.top/Math.max(1,root.offsetHeight-innerHeight)));
      root.style.setProperty('--progress',p);
      const phase=p<.22?0:p<.365?1:p<.565?2:3;
      root.querySelector('[data-phase-text]').textContent=mediaFailed?'NFC + QR · Essayez le Smart Link ci-dessous.':captions[phase];
      reveals.forEach(el=>el.classList.toggle('is-visible',p>=Number(el.dataset.reveal) && (!el.classList.contains('nfc-notice') || p<.60)));
      target=p*Math.max(0,(video.duration||0)-.04);
      if(!raf)raf=requestAnimationFrame(tick);
    }
    video.addEventListener('seeked',()=>{if(!raf)raf=requestAnimationFrame(tick)});
    video.addEventListener('loadedmetadata',sync);
    video.addEventListener('error',()=>{mediaFailed=true;root.classList.add('is-static');root.querySelector('[data-phase-text]').textContent='NFC + QR · Essayez le Smart Link ci-dessous.'});
    addEventListener('scroll',sync,{passive:true});addEventListener('resize',sync);
    const observer=new IntersectionObserver(([entry])=>{active=entry.isIntersecting;if(active){if(!mediaFailed && video.preload!=='auto'){video.preload='auto';video.load()}sync()}});
    observer.observe(root);
    root.querySelector('[data-demo]').addEventListener('click',()=>{if(reduce.matches || mediaFailed){root.querySelector('[data-interact]').click();return;}window.scrollTo({top:scrollY+root.getBoundingClientRect().top+(root.offsetHeight-innerHeight)*.44,behavior:'smooth'})});
    const device=root.querySelector('.nfc-livephone');
    const interact=root.querySelector('[data-interact]');
    interact.setAttribute('aria-expanded','false');
    interact.addEventListener('click',()=>{
      const sectionTop=scrollY+root.getBoundingClientRect().top;
      device.hidden=!device.hidden;
      root.classList.toggle('is-interactive',!device.hidden);
      interact.textContent=device.hidden?'Tester le Smart Link sur ce téléphone':'Revenir à l’animation';
      interact.setAttribute('aria-expanded',String(!device.hidden));
      // Changing a tall scroll section to a compact demo must not strand the
      // visitor below the content after the document height collapses.
      window.scrollTo({top:Math.max(0,sectionTop-64),behavior:'instant'});
      if(!device.hidden) device.querySelector('[data-live-page]:not([hidden]) button').focus({preventScroll:true});
      else sync();
    });
    root.querySelectorAll('[data-open-page]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-live-page]').forEach(page=>page.hidden=page.dataset.livePage!==b.dataset.openPage)}));
    let rating=0;root.querySelectorAll('[data-rating]').forEach(b=>b.addEventListener('click',()=>{rating=+b.dataset.rating;root.querySelectorAll('[data-rating]').forEach(star=>{star.textContent=+star.dataset.rating<=rating?'★':'☆';star.setAttribute('aria-pressed',String(+star.dataset.rating<=rating))})}));
    root.querySelector('[data-publish-demo]').addEventListener('click',()=>{root.querySelector('[data-review-result]').textContent=rating?'Démonstration terminée. Aucun avis n’a été publié.':'Choisissez une note pour essayer la démonstration.'});
    reduce.addEventListener('change',sync);sync();
  }
  document.querySelectorAll('[data-nfc-hero]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-nfc-hero]').forEach(mount));
})();
